__webpack_require__.p = "/wp-content/plugins/gwd-product-configurator/client-renderer/";